// @ts-nocheck
import { configureStorage } from './storage';

export const extractAccessTokenFromWindowLocation = window => {
    if (!window?.location?.href) {
        return; // eslint-disable-line no-undefined
    }

    if (typeof window.location.href !== 'string') {
        return; // eslint-disable-line no-undefined
    }

    let token = '';
    window.location.href.replace(/access_token=([^&]+)/u, (_, it) => {
        token = it;
    });

    return token;
};

export const configureAccessToken = (window, storage) => {
    const urlToken = extractAccessTokenFromWindowLocation(window);

    if (urlToken) {
        storage.saveAccessToken(urlToken);
    }

    return storage;
};

export const accessToken = configureAccessToken(typeof window === 'undefined' ? null : window, configureStorage());
